import { Grid } from "@mui/material";
import _ from "lodash";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import Button from "../../../framework/Button";
import GlobalContext from "../../../framework/GlobalContext";
import NumberInput from "../../../framework/NumberInput";
import Shortcut from "../../../framework/Shortcut";
import TextInput from "../../../framework/TextInput";
import { displayToast } from "../../../framework/toast/toastUtils";
import {
  fetchAllSpeciality,
  fetchQualifications,
  saveDoctor,
} from "../../../services/doctor-service";

import SelectInput from "../../../framework/SelectInput";
import {
  formStateHandler,
  isEmpty,
  isValidPhoneNumber,
} from "../../../utils/utils";
import { transformPayload } from "../DoctorConstants";
import classes from "./index.module.css";
import { doctorTypes } from "../../../utils/constant";

const AddDoctor = ({
  id,
  onSaveDoctor = () => {},
  onEscape = () => {},
  doctorData,
}) => {
  const [formState, setFormState] = useState({});
  const [errorStates, setErrorStates] = useState({});
  const withPhoneCap = ({ value }) => value.length <= 10;
  const withPincodeCap = ({ value }) => value.length <= 6;
  const doctorNameRef = useRef("");
  const doctorSpecialityRef = useRef("");
  const doctorProfessionRef = useRef("");
  const doctorMobileRef = useRef("");
  const doctorLandlineRef = useRef("");
  const doctorHospitalRef = useRef("");
  const doctorLicenseRef = useRef("");
  const doctorAddressRef = useRef("");
  const doctorPincodeRef = useRef("");
  const doctorTypeRef = useRef("");
  const doctorQualificationRef = useRef("");
  const remarksRef = useRef("");
  const saveDoctorRef = useRef();
  const { setCurrentComponent } = useContext(GlobalContext);
  const [professionOptions, setProfessionOptions] = useState([]);
  const [specialityOptions, setSpecialityOptions] = useState([]);

  const validateForm = useCallback(async (fieldName, data) => {
    if (fieldName === "doctorName" || !fieldName) {
      if (!data?.doctorName?.trim()) {
        displayToast({
          type: "error",
          title: "Please enter doctor name.",
        });
        doctorNameRef.current.focus();
        return false;
      }
    }
    // if (fieldName === "speciality" || !fieldName) {
    //   if (data && isEmpty(data?.speciality)) {
    //     displayToast({
    //       type: "error",
    //       title: "Please enter doctor speciality",
    //     });
    //     doctorSpecialityRef.current.focus();
    //     return false;
    //   }
    // }
    if (
      fieldName === "doctorPhone" ||
      fieldName === "landlineNumber" ||
      !fieldName
    ) {
      if (data && isEmpty(data?.doctorPhone) && isEmpty(data?.landlineNumber)) {
        displayToast({
          type: "error",
          title: "Please enter doctor phone number or Landline number",
        });
        doctorMobileRef.current.focus();
        return false;
      }
      if (data && data?.doctorPhone && !isValidPhoneNumber(data?.doctorPhone)) {
        displayToast({
          type: "error",
          title: "Please enter valid phone number",
        });
        doctorMobileRef.current.focus();
        return false;
      }
    }
    if (!fieldName || fieldName === "pincode") {
      if (data?.pincode && data.pincode.toString().length !== 6) {
        displayToast({
          type: "error",
          title: "Pincode must be at least 6 digits long.",
        });
        doctorPincodeRef.current.focus();
        return false;
      }
    }
    // if (fieldName === "licenceNo" || !fieldName) {
    //   if (data && isEmpty(data?.licenceNo)) {
    //     displayToast({
    //       type: "error",
    //       title: "Please enter doctor license",
    //     });
    //     doctorLicenseRef.current.focus();
    //     return false;
    //   }
    // }
    return true;
  }, []);
  const professionChangedHandler = useCallback(
    async (event, value) => {
      //removeErrorStateOnChange("add_product_manufacturer");
      if (!event) return;
      if (!event.target.value) return;
      if (value?.length > 2) {
        await fetchQualifications(`query=${value.trim()}`).then((response) => {
          let options =
            response?.rows?.map((professionData) => ({
              id: professionData.professionId,
              label: professionData.name,
            })) || [];
          setProfessionOptions(options);
        });
      }
    },
    [setProfessionOptions]
  );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounceDispatchQualificationChange = useCallback(
    _.debounce(professionChangedHandler, 300, { leading: true }),
    []
  );
  const specialityChangedHandler = useCallback(
    async (event, value) => {
      if (!event) return;
      if (!event.target.value) return;
      if (event.target.value?.length > 1) {
        try {
          const response = await fetchAllSpeciality(`name=${value.trim()}`);
          const options =
            response?.rows?.map((specialityData) => ({
              id: specialityData.specialityId,
              label: specialityData.name,
            })) || [];
          setSpecialityOptions(options);
        } catch (error) {
          console.error("Error fetching speciality:", error);
        }
      } else {
        setSpecialityOptions([]);
      }
    },
    [setSpecialityOptions]
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounceDispatchSpecialityChange = useCallback(
    _.debounce(specialityChangedHandler, 300, { leading: true }),
    []
  );

  const updateDoctorHandler = useCallback(
    async (e) => {
      if (!(await validateForm(null, formState))) return;
      const doctorPayload = transformPayload({
        ...formState,
        professionId:
          formState.profession?.id !== "custom"
            ? formState.profession?.id
            : undefined,
        name: formState?.profession?.label || null,
        specialityId:
          formState?.specialityId !== "custom"
            ? formState?.specialityId
            : undefined,
        specialityName: formState?.specialityName || null,
      });
      try {
        const savedDoctor = await saveDoctor(doctorPayload);
        onSaveDoctor(savedDoctor);
        displayToast({
          type: "success",
          title: "Doctor saved successfully.",
        });
      } catch (error) {
        console.error("Error saving doctor:", error);
        displayToast({
          type: "error",
          title: "An error occurred while saving doctor.",
        });
      }
    },
    [formState, onSaveDoctor, validateForm]
  );

  const keyupListener = useCallback(
    (event) => {
      const key = event.key?.toLowerCase();
      if (key === "escape") {
        return onEscape();
      }
      if (event.ctrlKey && key === "s") {
        return saveDoctorRef.current.click();
      }
    },
    [onEscape]
  );
  const handleFormChange = useCallback(
    (fieldName, fieldValue, isSelect = false, options, sendOption = false) => {
      const updatedFormState = formStateHandler(
        formState,
        fieldName,
        fieldValue,
        isSelect,
        options,
        sendOption
      );
      setFormState(updatedFormState);
    },
    [formState]
  );

  useEffect(() => {
    document.addEventListener("keyup", keyupListener, false);
    return () => {
      document.removeEventListener("keyup", keyupListener, false);
    };
  }, [keyupListener]);

  useEffect(() => {
    if (doctorData) {
      setFormState({
        ...doctorData,
        profession: doctorData.professionName || {},
        professionId: doctorData?.professionId || null,
        speciality: doctorData.specialityName || {},
        specialityId: doctorData?.specialityId || null,
        doctorType:
          doctorTypes.find((type) => type.id === doctorData?.doctorType) ||
          null,
      });
    }
  }, [doctorData]);
  return (
    <div>
      <h4 className={classes["user-detail-label"]}>Doctor Details</h4>
      {/* <div className={classes["edit-doctor-header-shortcuts"]}>
          <Shortcut keys={["Esc"]} label="Cancel" />
      </div> */}
      <Grid container spacing={2} sx={{ p: "25px 30px" }}>
        <Grid item xs={6}>
          <TextInput
            id="add_doctor_name"
            ref={doctorNameRef}
            name="doctorName"
            label="Doctor Name"
            required={true}
            onFocus={() => setCurrentComponent("add_doctor_name")}
            autoFocus
            onChange={(e) => {
              const sanitizedDoctorName = e.target.value.replace(
                /[^a-zA-Z\s.]/g,
                ""
              );
              handleFormChange("doctorName", sanitizedDoctorName);
              if (errorStates?.doctorName)
                setErrorStates((prev) => {
                  return { ...prev, doctorName: false };
                });
            }}
            value={formState?.doctorName || ""}
            inputProps={{
              "data-markers": JSON.stringify({
                right: "doctor_mobile",
                down: "doctor_hospital",
                up: "add_doctor_name",
                left: "add_doctor_name",
              }),
            }}
            InputProps={{ readOnly: !!id }}
            error={errorStates?.doctorName}
          />
        </Grid>
        <Grid item xs={3}>
          <NumberInput
            id="doctor_mobile"
            ref={doctorMobileRef}
            name="doctorPhone"
            label="Mobile"
            value={formState?.doctorPhone || ""}
            onFocus={() => setCurrentComponent("doctor_mobile")}
            isAllowed={withPhoneCap}
            allowNegative={false}
            decimalScale={0}
            required={!formState?.landlineNumber}
            onValueChange={(values, e) => {
              handleFormChange("doctorPhone", values.floatValue);
              if (errorStates?.doctorPhone)
                setErrorStates((prev) => {
                  return { ...prev, doctorPhone: false };
                });
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                right: "doctor_landline",
                down: "doctor_speciality",
                up: "doctor_mobile",
                left: "add_doctor_name",
              }),
            }}
            error={errorStates?.doctorPhone}
          />
        </Grid>
        <Grid item xs={3}>
          <TextInput
            id="doctor_landline"
            name="doctorLandline"
            label="Phone/Landline Number"
            ref={doctorLandlineRef}
            value={formState?.landlineNumber}
            onChange={(e) => {
              if (e.target.value?.length > 20) return;
              const landlineRegex = /^[0-9]*$/;
              if (!landlineRegex.test(e.target.value)) {
                return;
              }
              handleFormChange("landlineNumber", e.target.value);
            }}
            required={!formState?.doctorPhone}
            onFocus={() => setCurrentComponent("doctor_landline")}
            inputProps={{
              "data-markers": JSON.stringify({
                right: "doctor_profession",
                down: "doctor_license",
                up: "doctor_landline",
                left: "doctor_mobile",
              }),
            }}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ p: "0px 30px" }}>
        <Grid item xs={3}>
          <SelectInput
            id="doctor_profession"
            ref={doctorProfessionRef}
            name="profession"
            label="Profession"
            options={professionOptions}
            getOptionLabel={(option) => option.label || option}
            isOptionEqualToValue={(option, value) => {
              return option.label === value.label || value === "";
            }}
            value={formState?.profession || ""}
            disableClearable={false}
            onFocus={() => setCurrentComponent("doctor_profession")}
            freeSolo
            onInputChange={(e, value) => {
              if (!value) return handleFormChange("profession", null);
              if (value?.length > 2) {
                debounceDispatchQualificationChange(e, value);
              }
              handleFormChange("profession", {
                id: "custom",
                label: e.target.value,
              });
            }}
            onChange={(event, option) => {
              handleFormChange("profession", option);
            }}
            markers={JSON.stringify({
              up: "add_doctor_name",
              down: "doctor_address",
              right: "doctor_hospital",
              left: "doctor_landline",
            })}
            error={errorStates?.profession}
            required={false}
          />
        </Grid>
        <Grid item xs={3}>
          <TextInput
            id="doctor_hospital"
            ref={doctorHospitalRef}
            name="doctorHospital"
            label="Hospital"
            value={formState?.doctorHospital || ""}
            onFocus={() => setCurrentComponent("doctor_hospital")}
            onChange={(e) => {
              handleFormChange("doctorHospital", e.target.value);
              if (errorStates?.doctorHospital)
                setErrorStates((prev) => {
                  return { ...prev, doctorHospital: false };
                });
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                right: "doctor_speciality",
                down: "doctor_address",
                up: "add_doctor_name",
                left: "doctor_profession",
              }),
            }}
            error={errorStates?.doctorHospital}
          />
        </Grid>
        <Grid item xs={3}>
          <SelectInput
            id="doctor_speciality"
            inputRef={doctorSpecialityRef}
            name="speciality"
            label="Speciality"
            value={formState?.speciality}
            getOptionLabel={(option) => option.label || option}
            isOptionEqualToValue={(option, value) => {
              return option.label === value.label || value === "";
            }}
            options={specialityOptions}
            disableClearable={false}
            onFocus={() => setCurrentComponent("doctor_speciality")}
            freeSolo
            onChange={(e, option) => {
              setFormState((prev) => {
                return {
                  ...prev,
                  specialityId: option?.id,
                  specialityName: option?.label,
                };
              });
            }}
            onInputChange={(e, value) => {
              if (!e.target.value) {
                setFormState((prev) => {
                  return {
                    ...prev,
                    specialityId: null,
                    specialityName: null,
                  };
                });
                setSpecialityOptions([]);
                return;
              }
              if (e.target.value?.length > 1) {
                debounceDispatchSpecialityChange(e, value);
              }
              setFormState((prev) => {
                return {
                  ...prev,
                  specialityId: "custom",
                  specialityName: e.target.value,
                };
              });
            }}
            markers={JSON.stringify({
              right: "doctor_license",
              down: "doctor_address",
              up: "doctor_mobile",
              left: "doctor_hospital",
            })}
            error={errorStates?.speciality}
            required={false}
          />
        </Grid>
        <Grid item xs={3}>
          <TextInput
            id="doctor_license"
            ref={doctorLicenseRef}
            name="licenceNo"
            label="License"
            value={formState?.licenceNo || ""}
            onFocus={() => setCurrentComponent("doctor_license")}
            onChange={(e) => {
              handleFormChange("licenceNo", e.target.value);
              if (errorStates?.licenceNo)
                setErrorStates((prev) => {
                  return { ...prev, licenceNo: false };
                });
            }}
            required={false}
            inputProps={{
              "data-markers": JSON.stringify({
                right: "doctor_address",
                down: "doctor_pincode",
                up: "doctor_landline",
                left: "doctor_speciality",
              }),
            }}
            error={errorStates?.licenceNo}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ p: "25px 30px" }}>
        <Grid item xs={9}>
          <TextInput
            id="doctor_address"
            ref={doctorAddressRef}
            name="doctorAddress"
            label="Address"
            value={formState?.doctorAddress || ""}
            onFocus={() => setCurrentComponent("doctor_address")}
            onChange={(e) => {
              handleFormChange("doctorAddress", e.target.value);
              if (errorStates?.doctorAddress)
                setErrorStates((prev) => {
                  return { ...prev, doctorAddress: false };
                });
            }}
            onBlur={() => validateForm("doctorAddress", formState)}
            maxInputLength={10000}
            inputProps={{
              "data-markers": JSON.stringify({
                right: "doctor_pincode",
                down: "doctor_qualification",
                up: "doctor_hospital",
                left: "doctor_license",
              }),
            }}
            error={errorStates?.doctorAddress}
          />
        </Grid>
        <Grid item xs={3}>
          <NumberInput
            id="doctor_pincode"
            ref={doctorPincodeRef}
            name="pincode"
            label="Pincode"
            value={formState?.pincode || ""}
            decimalScale={0}
            onFocus={() => setCurrentComponent("doctor_pincode")}
            isAllowed={withPincodeCap}
            allowNegative={false}
            onValueChange={(values, e) => {
              handleFormChange("pincode", values.floatValue);
              if (errorStates?.pincode)
                setErrorStates((prev) => {
                  return { ...prev, pincode: false };
                });
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                right: "doctor_qualification",
                down: "remarks",
                up: "doctor_license",
                left: "doctor_address",
              }),
            }}
            error={errorStates?.pincode}
          />
        </Grid>
        <Grid item xs={3}>
          <TextInput
            id="doctor_qualification"
            ref={doctorQualificationRef}
            name="qualification"
            label="Qualification"
            value={formState?.qualification || ""}
            onFocus={() => setCurrentComponent("doctor_qualification")}
            onChange={(e) => {
              handleFormChange("qualification", e.target.value);
              if (errorStates?.qualification)
                setErrorStates((prev) => {
                  return { ...prev, qualification: false };
                });
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                right: "doctor_type_select",
                down: "doctor_qualification",
                up: "doctor_address",
                left: "doctor_pincode",
              }),
            }}
            error={errorStates?.qualification}
          />
        </Grid>
        <Grid item xs={3}>
          <SelectInput
            id="doctor_type_select"
            name="doctorType"
            ref={doctorTypeRef}
            label="Doctor Type"
            value={formState?.doctorType || ""}
            onFocus={() => setCurrentComponent("doctor_type_select")}
            onChange={(event, option) => {
              handleFormChange("doctorType", option);
            }}
            getOptionLabel={(option) => option.label || option}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            options={doctorTypes}
            markers={JSON.stringify({
              up: "doctor_qualification",
              down: "doctor_type_select",
              left: "doctor_qualification",
              right: "remarks",
            })}
          />
        </Grid>
        <Grid item xs={6}>
          <TextInput
            id="remarks"
            ref={remarksRef}
            name="remarks"
            label="Remarks"
            value={formState?.remarks || ""}
            onFocus={() => setCurrentComponent("remarks")}
            onChange={(e) => {
              handleFormChange("remarks", e.target.value);
              if (errorStates?.remarks)
                setErrorStates((prev) => {
                  return { ...prev, remarks: false };
                });
            }}
            maxInputLength={2000}
            inputProps={{
              "data-markers": JSON.stringify({
                right: "add_doctor_name",
                down: "remarks",
                up: "doctor_pincode",
                left: "doctor_type_select",
              }),
            }}
            error={errorStates?.remarks}
          />
        </Grid>
      </Grid>
      <div className={classes["add-user-save-button-wrapper"]}>
        <Button
          id="add_doctor_save_button"
          ref={saveDoctorRef}
          endIcon={<Shortcut keys={["Ctrl", "S"]} />}
          label="Save Doctor"
          color="violet"
          onClick={updateDoctorHandler}
        />
      </div>
    </div>
  );
};

export default AddDoctor;
